export const DIMENSIONS = [
  {
    short: "Negócio",
    title: "Negócio",
    questions: [
      "Temos uma ambição de crescimento clara para os próximos 12 meses — e ela está escrita.",
      "Sabemos de onde vem a receita: os produtos, serviços e clientes mais rentáveis estão medidos.",
      "As decisões estratégicas seguem critérios definidos, não o gosto ou a intuição do momento.",
      "O negócio cresce por demanda estruturada, não só pelo esforço dos fundadores e do time comercial.",
    ],
  },
  {
    short: "Marca",
    title: "Marca",
    questions: [
      "Nossa proposta de valor cabe em uma frase — e qualquer pessoa do time a repete sem hesitar.",
      "O mercado reconhece, sem explicação longa, por que somos diferentes.",
      "Nossa identidade visual e verbal sustenta o preço que cobramos.",
      "Vendemos por valor percebido, não por desconto.",
    ],
  },
  {
    short: "Cliente",
    title: "Cliente",
    questions: [
      "Sabemos exatamente o que o cliente avalia antes de nos escolher — e o que quase o fez desistir.",
      "As objeções mais comuns têm resposta pronta no discurso de todo o time.",
      "Medimos recompra, indicação e satisfação com regularidade.",
      "Nossa comunicação parte da dor do cliente, não das nossas credenciais.",
    ],
  },
  {
    short: "Mercado",
    title: "Mercado",
    questions: [
      "Acompanhamos concorrentes diretos e indiretos com método, não por acaso.",
      "Temos clareza de quem queremos ser na mente do cliente — e de quem não queremos ser.",
      "Sabemos quais nichos atacar e quais oportunidades recusar.",
      "Percebemos os movimentos do mercado antes que virem urgência.",
    ],
  },
  {
    short: "Marketing",
    title: "Marketing e Comunicação",
    questions: [
      "Site, redes sociais, apresentações e WhatsApp contam a mesma história, com o mesmo tom.",
      "Temos um funil comercial com etapas, responsáveis e indicadores definidos.",
      "A demanda qualificada chega por canais estruturados, não só por indicação.",
      "Medimos o retorno de cada canal e cortamos o que não performa.",
    ],
  },
];

export const level = (v) =>
  v < 40
    ? ["Crítico", "text-brand-red"]
    : v < 60
      ? ["Atenção", "text-brand-orange"]
      : v < 80
        ? ["Em evolução", "text-slate-300"]
        : ["Forte", "text-emerald-400"];
